<template>
  <el-tag v-if="size" type="warning" :hit="true" size="small">
    {{ size }}
  </el-tag>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'BannerSize',
  props: {
    size: {
      type: String,
      default: ''
    }
  },
  setup(props) {}
})
</script>
<style lang="scss" scoped>
.el-tag {
  border: none !important;
}
</style>
